<h4>{{title}}</h4>

<form
    id="certificationForm"
    name="certificationForm"
    novalidate
    autocomplete="off"
    #certificationForm="ngForm">
    <plan-amendment class="group"></plan-amendment>
    <staged-subdivision class="group"></staged-subdivision>
    <certification-survey-regulatory-statement class="group"></certification-survey-regulatory-statement>
    @if (isDigitalOrPortalPlan()) {
        <variation-approvals class="group"></variation-approvals>
        <survey-comments class="group"></survey-comments>
    }

    <div class="container-fluid">
        <div class="button-group">
            @if (isSaveVisible()) {
                <button
                    id="saveCertificationPageBtn"
                    type="button"
                    class="btn btn-default nlr-btn-sm validate"
                    title="Save Certification page data | Ctrl+S"
                    (click)="save()"
                    [disabled]="isSaveDisabled()">
                    Save
                </button>
            }
            @if (isValidateVisible()) {
                <button
                    id="validateCertificationPageBtn"
                    type="button"
                    class="btn btn-default nlr-btn-sm validate"
                    title="Validate Certification page data | V"
                    (click)="validate()"
                    [disabled]="isValidateDisabled()">
                    Validate
                </button>
            }
            @if (isCancelVisible()) {
                <button
                    id="cancelCertificationPageBtn"
                    type="button"
                    class="btn btn-warning nlr-btn-sm"
                    title="Clears all data on the Certification screen"
                    (click)="cancel()"
                    [disabled]="isCancelDisabled()">
                    Cancel
                </button>
            }
        </div>
    </div>
</form>
